import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import _ from 'lodash';
import { FlowType } from 'src/app/models/proofreading.model';
import { ProofreadingService } from 'src/app/services/proofreading.service';
import { ProjectService } from 'src/app/services/project.service';
import { IVersionSelector, ProofreadingHistoryService } from 'src/app/services/proofreading-history.service';
import { Id } from 'src/app/models/base.model';
import { Subscription } from 'rxjs';


interface IThumbnail {
    src: string;
}
@Component({
    selector: 'app-dashboard-history-detail',
    templateUrl: './dashboard-history-detail.component.html',
    styleUrls: ['./dashboard-history-detail.component.scss'],

})
export class DashboardHistoryDetailComponent implements OnInit, OnDestroy {
    public projectID: string;
    public proofreadingsID?: Id[];
    public mode: 'intern' | 'extern';
    public selectedVersion: IVersionSelector | null = null;

    public loading: boolean = true;
    public subscription: Subscription = new Subscription();

    get projectHistory() {
        return this.s_proofreadingHistory.projectHistories
    }

    get project() {
        return this.s_project.current;
    }

    constructor(
        protected s_proofreadingHistory: ProofreadingHistoryService,
        protected s_project: ProjectService,
        public dialogRef: MatDialogRef<DashboardHistoryDetailComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { projectID: string; proofreadingsID?: Id[], mode: 'intern' | 'extern'; }
    ) {
        this.projectID = data.projectID;
        this.proofreadingsID = data.proofreadingsID;
        this.mode = data.mode;

        this.subscription.add(
            this.s_proofreadingHistory.projectHistories$.subscribe(() => {
                this.loading = false;
            })
        );
    }

    async ngOnInit(): Promise<void> {
        this.loading = true;
        if (!this.proofreadingsID) {
            await this.s_project.getCurrent(this.projectID);
        } else {
            await this.s_project.getCurrent(this.projectID, {}, { emit: false });
            await this.s_proofreadingHistory.getRelatedProjectHistories(undefined, this.proofreadingsID);
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    getPrefixRelecture(flow: FlowType) {
        return ProofreadingService.getPrefixRelecture(flow);
    }

    getExternProofreadingsFromProjectHistories() {
        return this.projectHistory.map(ph => ph.extern?.proofreading!);
    }

    onSelectedVersionChange(selectedVersion: IVersionSelector | null) {
        this.selectedVersion = selectedVersion;
    }

    updateVersion(selectedVersion: IVersionSelector | null) {
        this.s_proofreadingHistory.selectedVersion$.next(selectedVersion);
    }
}